import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Icon } from '@iconify/react';

function WatchMan() {


    return (
        // <div className="w-full h-screen flex flex-col justify-center items-center bg-gradient-to-r from-gray-300 via-gray-400 to-gray-500 p-4">
           <>
            <div className="text-center mb-6">
                <h1 className="text-4xl font-extrabold text-white">Current Status</h1>
            </div>

            <div className='flex flex-row justify-center gap-5 w-full'>
                <div className="w-3/12 bg-gray-200 rounded-lg shadow-xl p-4 h-32 flex justify-center gap-5 items-center">
                  <div className='text-green-500 font-bold text-xl'>Storage</div>
                  <div className='text-green-500'><Icon icon="ooui:success" className='text-lg'/></div>
                </div>

                <div className="w-3/12 bg-gray-200 rounded-lg shadow-xl p-4 h-32 flex justify-center gap-5 items-center">
                  <div className='text-green-500 font-bold text-xl'>caches</div>
                  <div className='text-green-500'><Icon icon="ooui:success" className='text-lg'/></div>
                </div>

                <div className="w-3/12 bg-gray-200 rounded-lg shadow-xl p-4 h-32 flex justify-center gap-5 items-center">
                  <div className='text-green-500 font-bold text-xl'>databases</div>
                  <div className='text-green-500'><Icon icon="ooui:success" className='text-lg'/></div>
                </div>

            </div></>
        // </div>
    );
}

export default WatchMan;
